var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-medal-dialog" },
    [
      _c(
        "yxtf-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            width: "640px",
            cutline: false,
            "show-close": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "yxtbiz-medaldetail-headercontainer" },
            [
              _c("yxtf-portrait", {
                staticClass: "yxtbiz-medaldetail-headercontainer_logo",
                attrs: {
                  size: "120px",
                  username: _vm.userName,
                  imgUrl: _vm.userLogoUrl,
                },
              }),
              _c(
                "div",
                { staticClass: "yxtbiz-medaldetail-headercontainer_namebox" },
                [
                  _c(
                    "div",
                    { staticClass: "yxtbiz-medaldetail-headercontainer_name" },
                    [_c("yxtbiz-user-name", { attrs: { name: _vm.userName } })],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "yxtbiz-medaldetail-headercontainer_count" },
                    [_vm._v(_vm._s(_vm.formatCount))]
                  ),
                ]
              ),
              _c("yxtf-svg", {
                staticClass: "yxtbiz-medaldetail-headercontainer_infobg",
                attrs: {
                  "remote-url": _vm.mediaPath,
                  width: "271px",
                  height: "160px",
                  "icon-class": "medal-biz-infobg",
                },
              }),
              _c(
                "div",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [
                  _c("yxtf-svg", {
                    staticClass:
                      "yxtbiz-medaldetail-headercontainer_close hand",
                    attrs: {
                      "remote-url": _vm.mediaPath,
                      width: "24px",
                      height: "24px",
                      "icon-class": "close",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "yxtbiz-medaldetail-tablecontainer" },
            [
              _c(
                "yxtf-scrollbar",
                { attrs: { "fit-height": true } },
                _vm._l(_vm.gridData, function (item) {
                  return _c("medal-box", {
                    key: item.id,
                    attrs: {
                      myContinueDays: _vm.myContinueDays,
                      isSelf: _vm.isSelf,
                      data: item,
                    },
                  })
                }),
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }